import {Item, ProyectoItem} from "../../../interfaces/proyecto.interface";

export const norm = (v: unknown): string =>
    String(v ?? '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
const dateStrings = (d: unknown): string[] => {
    const dd =
        d instanceof Date ? d :
            (typeof d === 'string' ? new Date(d) : null);
    if (!dd || Number.isNaN(dd.getTime())) return [];
    const pad = (n: number) => `${n}`.padStart(2, '0');
    const iso = dd.toISOString().slice(0, 10);
    const dmy = `${pad(dd.getDate())}/${pad(dd.getMonth() + 1)}/${dd.getFullYear()}`;
    return [iso, dmy];
};
const isItem = (x: any): x is Item =>
    x && typeof x === 'object' &&
    ('sub_total' in x || 'nombre' in x || 'estado' in x);
const extractItems = (p: ProyectoItem): Item[] => {
    const root: any = (p as any)?.items;
    if (!root) return [];
    const collect = (node: any): Item[] => {
        if (!node) return [];
        if (Array.isArray(node)) {
            return node.flatMap(collect);
        }
        if (isItem(node)) {
            return [node];
        }
        if (typeof node === 'object') {
            if ('items' in node) return collect((node as any).items);
            return Object.values(node).flatMap(collect);
        }
        return [];
    };
    const out = collect(root);
    const seen = new Set<any>();
    return out.filter(it => {
        const k = (it as any).id ?? `${it.nombre}|${it.sub_total}|${it.fecha_creacion}`;
        if (seen.has(k)) return false;
        seen.add(k);
        return true;
    });
};
export const indexProyecto = (p: ProyectoItem): string => {
    const parts: string[] = [];
    const push = (v: unknown, weight = 1) => {
        const s = norm(v);
        if (!s) return;
        for (let i = 0; i < weight; i++) parts.push(s);
    };
    push(p.numeroExpediente, 3);
    push(p.nombre, 3);
    push(p.sector, 2);
    push(p.categoria, 2);
    push(p.institucion, 2);
    push(p.solicitudTipo, 2);
    push(p.estadoSolicitud, 2);
    push((p.proyectoEstado as any)?.toString?.() ?? (p.proyectoEstado as any));
    push((p.estado as any)?.toString?.() ?? (p.estado as any));
    const cli = p.cliente ?? p.titular;
    push((cli as any)?.nombreCompleto, 2);
    push((cli as any)?.telefono);
    push((cli as any)?.usuario);
    push((p.descripcion as any)?.toString?.() ?? (p.descripcion as any));
    push((p.naturaleza as any)?.toString?.());
    push((p.tipoProyecto as any)?.toString?.());
    push((p.entorno as any)?.toString?.());
    push((p.regimen as any)?.toString?.());
    push((p.tipoUsoSuelo as any)?.toString?.());
    for (const s of dateStrings(p.fechaCreacion)) push(s);
    for (const e of p.evaluaciones ?? []) {
        const anyE = e as any;
        push(anyE?.estado);
        push(anyE?.resultado);
        push(anyE?.observacion);
    }
    for (const it of extractItems(p)) {
        push(it.nombre, 2);
        push(it.estado);
        push(it.sub_total);
        for (const s of dateStrings(it.fecha_creacion)) push(s);
    }
    push(p.idProyecto);
    push(p.idSolicitud);
    push(p.idSolicitudTipo);
    push(p.idSolicitudEstado);
    return parts.join(' ');
};
